import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** PageHeader is the Header portion of a page layout */
const PageHeader = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("page-header", className)} {...other}>
      {children}
    </div>
  );
};

PageHeader.propTypes = {
  /** children will hold the header, footer, and body */
  children: PropTypes.node,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

PageHeader.defaultProps = {
  children: null,
  className: ""
};

export default PageHeader;
